export default {
    title: 'Schema builder',

    add: 'New property',
    addDict: 'New dictionary',
    removeDict: 'Remove dict',
    removeView: 'Remove view',
    reloadEntities: 'Reload entities',

    sections: {
        gps: 'GPs',
        funds: 'Funds',
        fundsPerf: 'Funds Performance',
        companies: 'Companies',
        companiesEvol: 'Companies Evolution',
        trans: 'Transactions',
        transPerf: 'Transactions Performance',
        dicts: 'Dicts',
        dictsDetail: 'Dicts',
        styles: 'Styles',
        transforms: 'Transforms',
    },

    actions: {
        createRow: 'New Row',
        editRow: 'Edit Row',
        delete: 'Delete',
        edit: 'Edit',
        audit: 'Audit',
        save: 'Save',
        export: 'Export',
        exportOptions: {
            title: 'As CSV (with friendly name columns)',
            camel: 'As CSV (with name columns ready to use it for import)',
        },
        viewDetail: 'View Detail',
        mergeSelection: 'Merge selection',
        deleteSelection: 'Delete selection',
        editSelection: 'Edit selection',
        addView: 'New view',
        allViews: 'All views',
        updateView: 'Edit name',
    },

    creation: {
        labels: {
            key: 'Identifier',
            name: 'Name',
            description: 'Description',
            group: 'Group',
            type: 'Type',
            defaultExpression: 'Default Expression',
            dataTrial: 'Data Trial',
            sampleId: 'Sample Data - Transaction ID',
            result: 'Result',
            errorType: 'Error Type',
            validators: 'Validators',
            dictionaries: 'Dictionary',
            styles: 'Style Transforms',
            hidden: 'Hidden',
            options: 'Options',
            visible: 'Visible',
            locked: 'Locked',
            editable: 'Editable',
            required: 'Required',
            unique: 'Unique',
            minValue: 'Min value',
            maxValue: 'Max value',
            minDate: 'Min value',
            maxDate: 'Max value',
            sources: 'Source Normalization Rules',
            validation: 'Validation',
            normalization: 'Normalization',
            style: 'Style',
            permissions: 'Permissions',
            priority: 'Priority',
            multiple: 'Multiple'
        },
        placeholder: {
            key: 'Identifier',
            name: 'Insert name',
            description: 'Insert the description',
            group: 'Select group',
            type: 'Type',
            defaultExpression: 'Insert the default expression',
            sampleId: 'Sample Id',
            validators: 'Validators',
            styles: 'Select new style',
            dictionary: 'Select dictionary',
            required: 'Required',
            unique: 'Unique',
            minValue: 'Min',
            maxValue: 'Max',
            minDate: 'DD-MM-YY',
            maxDate: 'DD-MM-YY',
            sources: 'Source identifier',
            sourcesType: 'Source type',
        },
        reset: 'Cancel',
        submit: 'Save',
        calculate: 'Calculate',
        loading: 'Loading',
        noData: 'N/D',
    },

    list: {
        key: 'Key',
        name: 'Name',
    },

    dicts: {
        items: 'Items',
        createDict: 'Create dictionary',
        editDict: 'Edit dictionary',
        newItem: 'New item',
        relations: 'Relations',
        newRelationship: 'New relationship',

        create: {
            key: {
                label: 'Key',
                placeholder: 'Insert key',
            },
            name: {
                label: 'Name',
                placeholder: 'Insert name',
            },
            reset: 'Cancel',
            submit: 'Save',
        },

        value: {
            value: {
                label: 'Display item',
                placeholder: 'Insert value',
            },
            reset: 'Cancel',
            submit: 'Create',
        },

        map: {
            alias: {
                label: 'Input data',
                placeholder: 'Insert input',
            },
            value: {
                label: 'Display data',
                placeholder: 'Select display data',
            },
            reset: 'Cancel',
            submit: 'Create',
        },
    },

    views: {
        create: {
            name: {
                label: 'Name',
                placeholder: 'Insert name',
                lengthError: 'The name cannot be greater than 100 characters.',
            },
            reset: 'Cancel',
            submit: 'Save',
        },
    },

    validations: {
        key: 'Identifier',
        name: 'Name',
        description: 'Description',
        priority: 'Priority',
    },

    modals: {
        remove: {
            text: 'Do you want to remove this entity?',
        },
        removeDict: {
            text: 'Do you want to remove this dictionary?',
        },
        createDictSuccess: {
            title: 'Great!',
            text: 'Dict created successfully.',
        },
        updateDictSuccess: {
            title: 'Great!',
            text: 'Dict updated successfully.',
        },
        createItemDict: {
            title: 'Great!',
            text: 'Item created successful.',
        },
        removeProp: {
            text: 'Do you want to remove this property?',
        },
        reload: {
            title: 'Great!',
            text: 'Entities reload successful.',
        },
        updateSuccess: {
            title: 'Great!',
            text: 'Updated successfully. It is necessary to refresh the state of the entity to see the final result.',
            link: 'Reload state',
        },
        editSuccess: {
            title: 'Great!',
            text: 'Updated successfully. After finish import you will see changes applied.',
        },
        editError: {
            title: 'Error!',
            text: 'Incorrect format data.',
        },
        removeSuccess: {
            title: 'Great!',
            text: 'Remove successfully.',
        },
        newView: {
            placeholder: 'View name',
            action: 'Create',
        },
        removeView: {
            text: 'Do you want to remove this view?',
        },
    },

    actionsModals: {
        deleteSelection: {
            text: 'Do you want to remove this rows?',
        },
        mergeSelection: {
            text: 'Do you want to merge this rows?',
        },
        editSelection: {
            text: 'Do you want to edit this value?',
        },
    },

    row: {
        text: {
            placeholder: 'Insert value',
        },
        date: {
            placeholder: 'Insert date',
        },
        select: {
            placeholder: 'Select option',
        },
    },

    reload: {
        options: {
            computed: 'Reload Entities',
            preqin: 'Reload Preqin Data',
            qreports: 'Reload Reporting Data',
        },

        notifications: {
            computed: {
                title: 'Great!',
                text: 'Entities reload successful.',
            },
            preqin: {
                title: 'Great!',
                text: 'Preqin Data reload successful.',
            },
            qreports: {
                title: 'Great!',
                text: 'Reporting Data reload successful.',
            },
        },
    },
}
